"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InlineErrorMessage = void 0;

var _react = _interopRequireDefault(require("react"));

var _nikeDesignSystemComponents = require("@nike/nike-design-system-components");

var _nikeDesignSystemIcons = require("@nike/nike-design-system-icons");

var _BoxStyled = require("./BoxStyled");

/**
 * @name InlineErrorMessage
 * @description A component rendering an inline error message.
 * @returns {JSX.Element}
 * @memberof privacy-shared-logic
 */
var InlineErrorMessage = function InlineErrorMessage(_ref) {
  var message = _ref.message;
  return /*#__PURE__*/_react.default.createElement(_BoxStyled.BoxStyled, {
    "data-testid": "inline-error-message",
    backgroundColor: "paletteGrey4",
    borderRadius: "4px"
  }, /*#__PURE__*/_react.default.createElement(_nikeDesignSystemComponents.Box, {
    width: "20px",
    height: "20px"
  }, /*#__PURE__*/_react.default.createElement(_nikeDesignSystemIcons.AlertCircle, null)), /*#__PURE__*/_react.default.createElement(_nikeDesignSystemComponents.Box, {
    padding: "0 0 0 12px"
  }, /*#__PURE__*/_react.default.createElement(_nikeDesignSystemComponents.TextStyled, {
    appearance: "body2"
  }, message)));
};

exports.InlineErrorMessage = InlineErrorMessage;